import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger.js'

gsap.registerPlugin(ScrollTrigger)

class PinnedLayers {
	constructor({ layers }) {
		this.layers = layers

		// create a trigger array containing the elements on which the ScrollTrigger should be applied
		// if a layer has nested child called data-layer-trigger then use that as trigger, otherwise use the layer itself
		this.triggers = Array.from(this.layers).map((layer) => {
			const trigger = layer.querySelector('[data-layer-trigger]')
			return trigger || layer
		})
	}

	init() {
		console.log('PinnedLayers init with layers:', this.layers)

		this.triggers.forEach((trigger) => {
			ScrollTrigger.create({
				trigger: trigger,
				start: 'bottom bottom',
				// markers: true,
				pinSpacing: false,
				pin: true,
				scrub: true,
			})
		})
	}

	destroy() {
		ScrollTrigger.getAll().forEach((trigger) => trigger.kill())
		this.triggers = []
	}
}

export default PinnedLayers
